import type { SupportedLocale } from '@erp/shared';
export const listViewTranslations = {
  de: {
    sortLabels: {
      paymentStatus: 'Zahlungsstatus',
      createdAt: 'Erstellt am',
      updatedAt: 'Geändert am',
    },
    filterNames: {
      priceGroupIds: 'Preisgruppe',
      productGroup: 'Artikelgruppe',
      customFieldFilters: 'Zusatzfeldfilter',
      status: 'Status',
      period: 'Zeitraum',
      sort: 'Sortierung',
      columns: 'Spalten',
    },
    title: 'Listenansichten',
    standard: 'Standardansicht',
    saveAs: 'Als neue Ansicht speichern',
    rename: 'Umbenennen',
    name: 'Name der Ansicht',
    shared: 'Im Mandanten gemeinsam nutzen',
    includeSearch: 'Suchabfrage ausdrücklich mitspeichern',
    dirty: 'Ungespeicherte Änderungen',
    makeDefault: 'Als persönliche Standardansicht',
    clearDefault: 'Persönlichen Standard aufheben',
    reset: 'Auf Standard zurücksetzen',
    reload: 'Aktuelle Ansicht neu laden',
    columns: 'Spalten und Reihenfolge',
    moveUp: '{{name}} nach vorn',
    moveDown: '{{name}} nach hinten',
    saved: 'Ansicht gespeichert',
    description:
      'Gespeichert werden Einstellungen, keine Datensätze. Gemeinsame Ansichten erweitern keine Berechtigungen.',
    blocked:
      'Diese Ansicht ist gesperrt, bis die folgenden Einstellungen korrigiert oder bewusst entfernt wurden. Es werden keine erweiterten Ergebnisse angezeigt.',
    removeSetting: 'Einstellung bewusst entfernen',
    invalid: 'Die Ansicht enthält ungültige Einstellungen. Bitte korrigieren oder zurücksetzen.',
    wrongList: 'Diese Ansicht gehört zu einer anderen Liste.',
    conflict:
      'Die Ansicht wurde zwischenzeitlich geändert. Bitte neu laden und Änderungen erneut übernehmen.',
    deleteTitle: 'Ansicht „{{name}}“ löschen?',
    deleteDescription:
      'Die gespeicherten Einstellungen werden entfernt. Geschäftsdaten bleiben erhalten.',
    discardTitle: 'Ungespeicherte Änderungen verwerfen?',
    discardDescription: 'Die aktuellen Änderungen gehen verloren.',
    discard: 'Verwerfen',
    period: 'Zeitraum',
    fixedDates: 'Feste Datumsgrenzen / alle',
    thisWeek: 'Diese Woche',
    thisMonth: 'Dieser Monat',
    sort: 'Sortierung',
    asc: 'Aufsteigend',
    desc: 'Absteigend',
    search: 'Chargennummer suchen',
    allStatuses: 'Alle Status',
    allDates: 'Alle Restlaufzeiten',
    reasons: {
      UNSUPPORTED: 'Nicht mehr unterstützt',
      UNAVAILABLE: 'Nicht mehr vorhanden oder nicht lesbar',
      INVALID: 'Ungültiger Wert oder geänderte Feldkonfiguration',
    },
  },
  en: {
    sortLabels: {
      paymentStatus: 'Payment status',
      createdAt: 'Created on',
      updatedAt: 'Updated on',
    },
    filterNames: {
      priceGroupIds: 'Price group',
      productGroup: 'Product group',
      customFieldFilters: 'Custom field filter',
      status: 'Status',
      period: 'Period',
      sort: 'Sorting',
      columns: 'Columns',
    },
    title: 'List views',
    standard: 'Standard view',
    saveAs: 'Save as new view',
    rename: 'Rename',
    name: 'View name',
    shared: 'Share within tenant',
    includeSearch: 'Include the current search query',
    dirty: 'Unsaved changes',
    makeDefault: 'Make my default view',
    clearDefault: 'Clear my default',
    reset: 'Reset to standard',
    reload: 'Reload current view',
    columns: 'Columns and order',
    moveUp: 'Move {{name}} earlier',
    moveDown: 'Move {{name}} later',
    saved: 'View saved',
    description:
      'Only settings are saved, never records. Shared views do not grant additional permissions.',
    blocked:
      'This view is blocked until the following settings are corrected or explicitly removed. Broader results will not be shown.',
    removeSetting: 'Explicitly remove setting',
    invalid: 'The view contains invalid settings. Correct or reset them.',
    wrongList: 'This view belongs to a different list.',
    conflict: 'The view has changed. Reload it before applying your changes again.',
    deleteTitle: 'Delete view “{{name}}”?',
    deleteDescription: 'The saved settings will be removed. Business records remain intact.',
    discardTitle: 'Discard unsaved changes?',
    discardDescription: 'Your current changes will be lost.',
    discard: 'Discard',
    period: 'Period',
    fixedDates: 'Fixed dates / all',
    thisWeek: 'This week',
    thisMonth: 'This month',
    sort: 'Sort order',
    asc: 'Ascending',
    desc: 'Descending',
    search: 'Search batch number',
    allStatuses: 'All statuses',
    allDates: 'All shelf lives',
    reasons: {
      UNSUPPORTED: 'No longer supported',
      UNAVAILABLE: 'Missing or no longer readable',
      INVALID: 'Invalid value or changed field configuration',
    },
  },
  tr: {
    sortLabels: {
      paymentStatus: 'Ödeme durumu',
      createdAt: 'Oluşturulma tarihi',
      updatedAt: 'Güncelleme tarihi',
    },
    filterNames: {
      priceGroupIds: 'Fiyat grubu',
      productGroup: 'Ürün grubu',
      customFieldFilters: 'Ek alan filtresi',
      status: 'Durum',
      period: 'Dönem',
      sort: 'Sıralama',
      columns: 'Sütunlar',
    },
    title: 'Liste görünümleri',
    standard: 'Standart görünüm',
    saveAs: 'Yeni görünüm olarak kaydet',
    rename: 'Yeniden adlandır',
    name: 'Görünüm adı',
    shared: 'Kiracı içinde paylaş',
    includeSearch: 'Geçerli arama sorgusunu dahil et',
    dirty: 'Kaydedilmemiş değişiklikler',
    makeDefault: 'Kişisel varsayılan yap',
    clearDefault: 'Kişisel varsayılanı kaldır',
    reset: 'Standarda sıfırla',
    reload: 'Geçerli görünümü yeniden yükle',
    columns: 'Sütunlar ve sıralama',
    moveUp: '{{name}} öne taşı',
    moveDown: '{{name}} arkaya taşı',
    saved: 'Görünüm kaydedildi',
    description:
      'Yalnızca ayarlar kaydedilir, kayıtlar kaydedilmez. Paylaşılan görünümler ek yetki vermez.',
    blocked:
      'Aşağıdaki ayarlar düzeltilene veya bilinçli olarak kaldırılana kadar bu görünüm engellenir. Daha geniş sonuçlar gösterilmez.',
    removeSetting: 'Ayarı bilinçli olarak kaldır',
    invalid: 'Görünüm geçersiz ayarlar içeriyor. Düzeltin veya sıfırlayın.',
    wrongList: 'Bu görünüm başka bir listeye ait.',
    conflict: 'Görünüm değişti. Değişikliklerinizi yeniden uygulamadan önce yükleyin.',
    deleteTitle: '“{{name}}” görünümü silinsin mi?',
    deleteDescription: 'Kaydedilen ayarlar kaldırılır. İş kayıtları korunur.',
    discardTitle: 'Kaydedilmemiş değişiklikler silinsin mi?',
    discardDescription: 'Geçerli değişiklikleriniz kaybolur.',
    discard: 'Vazgeç',
    period: 'Dönem',
    fixedDates: 'Sabit tarihler / tümü',
    thisWeek: 'Bu hafta',
    thisMonth: 'Bu ay',
    sort: 'Sıralama',
    asc: 'Artan',
    desc: 'Azalan',
    search: 'Parti numarası ara',
    allStatuses: 'Tüm durumlar',
    allDates: 'Tüm kalan raf ömürleri',
    reasons: {
      UNSUPPORTED: 'Artık desteklenmiyor',
      UNAVAILABLE: 'Eksik veya artık okunamıyor',
      INVALID: 'Geçersiz değer veya değişen alan yapılandırması',
    },
  },
  fr: {
    sortLabels: {
      paymentStatus: 'État du paiement',
      createdAt: 'Créé le',
      updatedAt: 'Modifié le',
    },
    filterNames: {
      priceGroupIds: 'Groupe tarifaire',
      productGroup: 'Groupe d’articles',
      customFieldFilters: 'Filtre de champ personnalisé',
      status: 'Statut',
      period: 'Période',
      sort: 'Tri',
      columns: 'Colonnes',
    },
    title: 'Vues de liste',
    standard: 'Vue standard',
    saveAs: 'Enregistrer une nouvelle vue',
    rename: 'Renommer',
    name: 'Nom de la vue',
    shared: 'Partager dans le tenant',
    includeSearch: 'Inclure la recherche actuelle',
    dirty: 'Modifications non enregistrées',
    makeDefault: 'Définir comme vue personnelle par défaut',
    clearDefault: 'Retirer ma vue par défaut',
    reset: 'Revenir à la vue standard',
    reload: 'Recharger la vue actuelle',
    columns: 'Colonnes et ordre',
    moveUp: 'Avancer {{name}}',
    moveDown: 'Reculer {{name}}',
    saved: 'Vue enregistrée',
    description:
      'Seuls les réglages sont enregistrés, jamais les données. Une vue partagée ne donne aucun droit supplémentaire.',
    blocked:
      'Cette vue est bloquée jusqu’à correction ou suppression explicite des réglages suivants. Aucun résultat élargi ne sera affiché.',
    removeSetting: 'Supprimer ce réglage explicitement',
    invalid: 'La vue contient des réglages invalides. Corrigez-les ou réinitialisez-les.',
    wrongList: 'Cette vue appartient à une autre liste.',
    conflict: 'La vue a changé. Rechargez-la avant de réappliquer vos modifications.',
    deleteTitle: 'Supprimer la vue « {{name}} » ?',
    deleteDescription:
      'Les réglages enregistrés seront supprimés. Les données métier sont conservées.',
    discardTitle: 'Abandonner les modifications non enregistrées ?',
    discardDescription: 'Vos modifications actuelles seront perdues.',
    discard: 'Abandonner',
    period: 'Période',
    fixedDates: 'Dates fixes / toutes',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois-ci',
    sort: 'Tri',
    asc: 'Croissant',
    desc: 'Décroissant',
    search: 'Rechercher un numéro de lot',
    allStatuses: 'Tous les statuts',
    allDates: 'Toutes les durées restantes',
    reasons: {
      UNSUPPORTED: 'N’est plus pris en charge',
      UNAVAILABLE: 'Absent ou plus accessible',
      INVALID: 'Valeur invalide ou configuration du champ modifiée',
    },
  },
  es: {
    sortLabels: {
      paymentStatus: 'Estado de pago',
      createdAt: 'Fecha de creación',
      updatedAt: 'Fecha de modificación',
    },
    filterNames: {
      priceGroupIds: 'Grupo de precios',
      productGroup: 'Grupo de artículos',
      customFieldFilters: 'Filtro de campo adicional',
      status: 'Estado',
      period: 'Período',
      sort: 'Ordenación',
      columns: 'Columnas',
    },
    title: 'Vistas de lista',
    standard: 'Vista estándar',
    saveAs: 'Guardar como vista nueva',
    rename: 'Renombrar',
    name: 'Nombre de la vista',
    shared: 'Compartir en el tenant',
    includeSearch: 'Incluir la búsqueda actual',
    dirty: 'Cambios sin guardar',
    makeDefault: 'Establecer como predeterminada personal',
    clearDefault: 'Quitar mi vista predeterminada',
    reset: 'Restablecer vista estándar',
    reload: 'Volver a cargar la vista actual',
    columns: 'Columnas y orden',
    moveUp: 'Adelantar {{name}}',
    moveDown: 'Retrasar {{name}}',
    saved: 'Vista guardada',
    description:
      'Solo se guardan ajustes, nunca registros. Las vistas compartidas no otorgan permisos adicionales.',
    blocked:
      'Esta vista está bloqueada hasta corregir o eliminar expresamente los siguientes ajustes. No se mostrarán resultados ampliados.',
    removeSetting: 'Eliminar este ajuste expresamente',
    invalid: 'La vista contiene ajustes no válidos. Corríjalos o restablézcalos.',
    wrongList: 'Esta vista pertenece a otra lista.',
    conflict: 'La vista ha cambiado. Vuelva a cargarla antes de aplicar sus cambios.',
    deleteTitle: '¿Eliminar la vista «{{name}}»?',
    deleteDescription: 'Se eliminarán los ajustes guardados. Los registros se conservan.',
    discardTitle: '¿Descartar los cambios sin guardar?',
    discardDescription: 'Se perderán los cambios actuales.',
    discard: 'Descartar',
    period: 'Período',
    fixedDates: 'Fechas fijas / todas',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    sort: 'Ordenación',
    asc: 'Ascendente',
    desc: 'Descendente',
    search: 'Buscar número de lote',
    allStatuses: 'Todos los estados',
    allDates: 'Todas las vidas útiles restantes',
    reasons: {
      UNSUPPORTED: 'Ya no es compatible',
      UNAVAILABLE: 'No existe o ya no es legible',
      INVALID: 'Valor no válido o configuración del campo modificada',
    },
  },
} as const satisfies Record<SupportedLocale, Record<string, string | Record<string, string>>>;
